"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidReceivedEvent = void 0;
const validation_1 = require("../../validation");
const base_1 = require("./base");
var BidReceivedEvent;
(function (BidReceivedEvent) {
    BidReceivedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.MARKETPLACE },
            subType: { type: 'string', const: base_1.Events.SubType.Marketplace.BID_RECEIVED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 0 },
            metadata: {
                type: 'object',
                properties: {
                    address: { type: 'string' },
                    image: { type: 'string' },
                    seller: { type: 'string' },
                    category: { type: 'string' },
                    rarity: { type: 'string', nullable: true },
                    link: { type: 'string' },
                    nftName: { type: 'string', nullable: true },
                    price: { type: 'string' },
                    title: { type: 'string' },
                    description: { type: 'string' },
                    network: { type: 'string' }
                },
                required: ['address', 'image', 'seller', 'category', 'link', 'price', 'title', 'network']
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
    BidReceivedEvent.validate = (0, validation_1.generateLazyValidator)(BidReceivedEvent.schema);
})(BidReceivedEvent = exports.BidReceivedEvent || (exports.BidReceivedEvent = {}));
//# sourceMappingURL=marketplace.js.map